<template>
  <div class="page_batchJobManage">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" size="small">
            <el-form-item label="用户ID" size="small">
              <el-input-number v-model="listQuery.userId" :min="1" :controls="false" size="small" style="width:140px" @keyup.enter.native="searchHandle"></el-input-number>
            </el-form-item>
            <el-form-item label="状态" size="small">
              <el-select v-model="listQuery.status" placeholder="" clearable size="small" style="width:140px">
                <el-option v-for="(name, idx) in statusNames" :key="idx" :label="name" :value="String(idx)"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="每页" size="small">
              <el-select v-model="listQuery.pageSize" size="small" style="width:110px" @change="searchHandle">
                <el-option :value="20" label="20 条"></el-option>
                <el-option :value="50" label="50 条"></el-option>
                <el-option :value="100" label="100 条"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-checkbox v-model="autoRefresh" style="margin-right:15px">5 秒自动刷新</el-checkbox>
        <el-tag type="warning" size="small" style="margin-right:15px">{{ activeCount }} 个活动任务</el-tag>
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>AI 工作台</el-breadcrumb-item>
          <el-breadcrumb-item>批处理任务</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="load">立即刷新</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column key="job" label="任务 / 工作流" min-width="180" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <strong>#{{ row.id }}</strong><br>
              <small>{{ row.toolName || '未命名工作流' }} · {{ row.stepCount }} 步</small>
            </template>
          </el-table-column>
          <el-table-column key="status" label="状态" min-width="100" align="center">
            <template slot-scope="{row}">
              <el-tag :type="statusTagType(row.status)" size="mini">{{ statusNames[row.status] || '未知' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column key="progress" label="进度" min-width="160" align="center">
            <template slot-scope="{row}">
              <el-progress :percentage="progress(row)" :stroke-width="10" :status="progressStatus(row.status)"></el-progress>
            </template>
          </el-table-column>
          <el-table-column key="stat" label="记录统计" min-width="180" align="center">
            <template slot-scope="{row}">
              <strong>{{ row.succeededCount }} 成功 / {{ row.failedCount }} 失败</strong><br>
              <small>{{ row.runningCount }} 执行中 · {{ row.pendingCount }} 等待</small>
            </template>
          </el-table-column>
          <el-table-column key="createTime" label="创建时间" min-width="150" align="center">
            <template slot-scope="{row}">{{ formatTime(row.createTime) }}</template>
          </el-table-column>
          <el-table-column key="action" label="操作" fixed="right" align="center" width="220">
            <template slot-scope="{row}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="showDetail(row.id)">详情</el-button>
                <el-button v-if="row.status < 2" type="text" size="small" :loading="operating === row.id" @click="cancelJob(row)">取消</el-button>
                <el-button v-if="row.status === 3" type="text" size="small" :loading="operating === row.id" @click="retryJob(row)">重试失败项</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.page" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 任务详情 -->
    <el-dialog :title="'批处理任务 #' + (selected && selected.id || '')" :visible.sync="detailOpen" width="980px" class="res_dialog" :close-on-click-modal="false" top="5vh">
      <template v-if="selected">
        <div class="section-heading">
          <div>
            <strong>{{ selected.toolName || '未命名工作流' }}</strong>
            <small style="margin-left:8px;color:#909399">{{ progress(selected) }}% 完成</small>
          </div>
        </div>
        <el-row :gutter="12" class="summary-grid">
          <el-col :span="6">
            <div class="summary-card"><span>状态</span><strong>{{ statusNames[selected.status] }}</strong></div>
          </el-col>
          <el-col :span="6">
            <div class="summary-card"><span>成功</span><strong>{{ selected.succeededCount }}</strong><small>共 {{ selected.totalCount }} 条</small></div>
          </el-col>
          <el-col :span="6">
            <div class="summary-card"><span>失败</span><strong>{{ selected.failedCount }}</strong><small>{{ selected.runningCount }} 条执行中</small></div>
          </el-col>
          <el-col :span="6">
            <div class="summary-card"><span>时间</span><strong>{{ formatTime(selected.createTime) }}</strong><small>结束 {{ formatTime(selected.finishTime) }}</small></div>
          </el-col>
        </el-row>

        <div class="section-heading" style="margin-top:18px">
          <strong>记录执行明细</strong>
          <div class="detail-actions">
            <el-select v-model="itemStatus" size="mini" placeholder="全部记录" clearable style="width:130px" @change="itemPage = 1; loadDetail(selected.id)">
              <el-option v-for="(name, idx) in statusNames" :key="idx" :label="name" :value="String(idx)"></el-option>
            </el-select>
            <el-button v-if="selected.failedCount" type="text" size="mini" @click="exportFailures(selected)">导出失败项</el-button>
          </div>
        </div>
        <el-collapse v-model="activeItems" class="batch-items">
          <el-collapse-item v-for="item in items" :key="item.id" :name="item.id">
            <template slot="title">
              <strong>#{{ item.itemIndex }} {{ item.itemKey || '' }}</strong>
              <el-tag :type="statusTagType(item.status)" size="mini" style="margin:0 8px">{{ statusNames[item.status] }}</el-tag>
              <small v-if="item.nextRetryTime">重试于 {{ formatTime(item.nextRetryTime) }}</small>
              <small v-else-if="item.deadLetterTime">死信于 {{ formatTime(item.deadLetterTime) }}</small>
              <small v-else-if="item.errorCode">{{ item.errorCode }}</small>
              <small v-else>{{ (item.steps || []).length }} 个步骤</small>
            </template>
            <div v-if="item.errorMessage" class="job-error">
              <strong>{{ item.errorCode }}</strong>
              <p>{{ item.errorMessage }}</p>
            </div>
            <el-row :gutter="12" class="json-grid">
              <el-col :span="12"><h4>源记录</h4><pre>{{ prettyJson(item.arguments) }}</pre></el-col>
              <el-col :span="12"><h4>聚合结果</h4><pre>{{ prettyJson(item.result) }}</pre></el-col>
            </el-row>
            <div v-for="step in (item.steps || [])" :key="step.stepIndex" class="batch-step">
              <header>
                <strong>{{ step.stepIndex + 1 }}. {{ step.stepKey }}</strong>
                <code>{{ step.toolName }}</code>
                <el-tag :type="statusTagType(step.status)" size="mini">{{ statusNames[step.status] || '跳过' }}</el-tag>
              </header>
              <p v-if="step.errorMessage" class="danger">{{ step.errorCode }} · {{ step.errorMessage }}</p>
              <el-row :gutter="12" class="json-grid">
                <el-col :span="12"><h4>实际参数</h4><pre>{{ prettyJson(step.resolvedArguments) }}</pre></el-col>
                <el-col :span="12"><h4>返回结果</h4><pre>{{ prettyJson(step.result) }}</pre></el-col>
              </el-row>
            </div>
          </el-collapse-item>
        </el-collapse>
        <div v-if="!items.length" style="color:#909399;padding:20px 0">当前筛选条件下暂无记录</div>
        <div class="block">
          <el-pagination v-if="itemTotal > 0" @current-change="itemCurrentChange" :current-page.sync="itemPage" :page-size="50" layout="total, prev, pager, next, jumper" :total="itemTotal"></el-pagination>
        </div>

        <div class="section-heading" style="margin-top:18px">
          <strong>事件时间线</strong>
          <small style="color:#909399">最多显示最近 200 条事件</small>
        </div>
        <div class="job-event-list">
          <div v-for="event in events" :key="event.sequence" class="event-row">
            <strong>{{ event.eventType }}</strong>
            <span>{{ event.message || '—' }}</span>
            <small>#{{ event.sequence }} · {{ formatTime(event.createTime) }}</small>
          </div>
          <div v-if="!events.length" style="color:#909399;padding:10px 0">暂无事件</div>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailOpen = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import signalR from '@/utils/signalR';
  const APIAwBase = 'http://10.0.0.10:2205';
  export default {
    data() {
      return {
        statusNames: ['待执行', '执行中', '成功', '失败', '已取消'],
        listQuery: { userId: Number(Cookies.get("userid-b")) || 1, status: '', page: 1, pageSize: 20 },
        tableData: [],
        totalCount: 0,
        loading: false,
        autoRefresh: true,
        detailOpen: false,
        operating: '',
        selected: null,
        items: [],
        events: [],
        itemStatus: '',
        itemPage: 1,
        itemTotal: 0,
        activeItems: [],
        connection: null,
        subscribedUserId: null,
        timer: null
      }
    },
    computed: {
      activeCount() {
        return this.tableData.filter(job => job.status < 2).length;
      }
    },
    created() {
      this.load();
      this.connectRealtime();
      this.timer = window.setInterval(() => {
        if (this.autoRefresh && this.activeCount) this.load(true);
      }, 5000);
    },
    beforeDestroy() {
      window.clearInterval(this.timer);
      signalR.stopConnection(this.connection);
    },
    methods: {
      currentChange(val) {
        this.listQuery.page = Number(val);
        this.load();
      },
      handleSizeChange(val) {
        this.listQuery.page = 1;
        this.listQuery.pageSize = val;
        this.load();
      },
      itemCurrentChange(val) {
        this.itemPage = Number(val);
        this.loadDetail(this.selected.id);
      },
      searchHandle() {
        this.listQuery.page = 1;
        this.load();
      },
      buildQuery(silent) {
        let q = { userId: Number(this.listQuery.userId), page: this.listQuery.page, pageSize: this.listQuery.pageSize };
        if (this.listQuery.status !== '') q.status = this.listQuery.status;
        return q;
      },
      load(silent) {
        if (Number(this.listQuery.userId) <= 0) {
          this.$message.error('User ID 必须大于 0');
          return;
        }
        if (!silent) this.loading = true;
        xz.getBatchJobList(this.buildQuery()).then(res => {
          if (res) {
            this.tableData = res.items || [];
            this.totalCount = res.totalCount || 0;
          } else if (!silent) {
            this.tableData = [];
            this.totalCount = 0;
          }
          this.subscribeRealtime();
          if (this.selected && this.detailOpen) this.loadDetail(this.selected.id, true);
          this.loading = false;
        }).catch(() => { if (!silent) { this.tableData = []; this.totalCount = 0; this.loading = false; } });
      },
      loadDetail(jobId, silent) {
        let userId = Number(this.listQuery.userId);
        let itemQuery = { userId, page: this.itemPage, pageSize: 50 };
        if (this.itemStatus !== '') itemQuery.status = this.itemStatus;
        Promise.all([
          xz.getBatchJobDetail(jobId, userId),
          xz.getBatchJobItems(jobId, itemQuery),
          xz.getBatchJobEvents(jobId, userId)
        ]).then(([job, itemResult, eventResult]) => {
          this.selected = job || this.selected;
          this.items = (itemResult && itemResult.items) || [];
          this.itemTotal = (itemResult && itemResult.totalCount) || 0;
          this.events = eventResult || [];
          if (!silent) this.detailOpen = true;
        }).catch(() => { if (!silent) this.$message.error('获取详情失败'); });
      },
      showDetail(id) {
        this.itemPage = 1;
        this.itemStatus = '';
        this.activeItems = [];
        this.loadDetail(id);
      },
      cancelJob(row) {
        this.$confirm(`确定取消批任务 ${row.id} 吗？正在调用的外部工具可能无法撤回。`, '提示', { type: 'warning' }).then(() => {
          this.operating = row.id;
          xz.cancelBatchJob(row.id, Number(this.listQuery.userId)).then(res => {
            this.operating = '';
            if (res !== false) { this.$message.success('取消请求已提交'); this.load(true); }
            else this.$message.error('取消失败');
          }).catch(() => { this.operating = ''; });
        }).catch(() => {});
      },
      retryJob(row) {
        this.$confirm(`确定重新执行批任务 ${row.id} 的失败记录吗？`, '提示', { type: 'warning' }).then(() => {
          this.operating = row.id;
          xz.retryBatchJobFailures(row.id, Number(this.listQuery.userId)).then(res => {
            this.operating = '';
            if (res !== false) { this.$message.success('失败记录已重新排队'); this.load(true); }
            else this.$message.error('重试失败');
          }).catch(() => { this.operating = ''; });
        }).catch(() => {});
      },
      exportFailures(job) {
        let userId = encodeURIComponent(this.listQuery.userId);
        window.location.assign(`${APIAwBase}/aw/batch-jobs/${encodeURIComponent(job.id)}/failed-items.ndjson?userId=${userId}`);
      },
      progress(job) {
        return job && job.totalCount ? Math.round((job.succeededCount + job.failedCount) * 100 / job.totalCount) : 0;
      },
      progressStatus(status) {
        if (status === 2) return 'success';
        if (status === 3) return 'exception';
        return undefined;
      },
      statusTagType(val) {
        if (val === 2) return 'success';
        if (val === 3) return 'danger';
        if (val === 4) return 'info';
        if (val === 1) return 'warning';
        return 'info';
      },
      formatTime(value) {
        return value ? new Date(value).toLocaleString('zh-CN', { hour12: false }) : '—';
      },
      prettyJson(value) {
        if (!value) return '—';
        try { return JSON.stringify(typeof value === 'string' ? JSON.parse(value) : value, null, 2); }
        catch (e) { return String(value); }
      },
      async subscribeRealtime() {
        if (!this.connection || this.connection.state !== 'Connected') return;
        let next = Number(this.listQuery.userId);
        if (this.subscribedUserId === next) return;
        if (this.subscribedUserId) {
          try { await this.connection.invoke('LeaveBatchJobs', this.subscribedUserId); } catch (e) {}
        }
        try { await this.connection.invoke('JoinBatchJobs', next); this.subscribedUserId = next; } catch (e) {}
      },
      async connectRealtime() {
        this.connection = signalR.createConnection(`${APIAwBase}/agentHub`);
        this.connection.on('batch_job_event', (event) => {
          this.load(true);
          if (this.detailOpen && this.selected && event && event.jobId === this.selected.id) {
            this.loadDetail(event.jobId, true);
          }
        });
        this.connection.onreconnected(async () => {
          this.subscribedUserId = null;
          await this.subscribeRealtime();
          await this.load(true);
        });
        this.connection.onclose(() => { this.subscribedUserId = null; });
        const ok = await signalR.startConnection(this.connection);
        if (!ok) {
          this.$message.warning('实时连接失败，已使用轮询兜底');
        } else {
          this.subscribeRealtime();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }
  .ftabBtn {
    padding: 10px 0;
  }
  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }
  .section-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 12px 0 8px;
  }
  .detail-actions {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .summary-grid {
    margin-bottom: 8px;
  }
  .summary-card {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 10px;
    text-align: center;
    span { display: block; color: #909399; font-size: 12px; }
    strong { display: block; font-size: 18px; margin: 4px 0; }
    small { color: #909399; font-size: 12px; }
  }
  .batch-items {
    border-top: 1px solid #ebeef5;
  }
  .batch-step {
    background: #fafafa;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 8px 10px;
    margin: 8px 0;
    header { display: flex; align-items: center; gap: 10px; margin-bottom: 6px; }
    code { background: #f0f2f5; padding: 1px 6px; border-radius: 3px; font-size: 12px; }
  }
  .json-grid {
    h4 { margin: 6px 0 4px; color: #606266; font-size: 13px; }
    pre { background: #f5f7fa; border: 1px solid #ebeef5; border-radius: 4px; padding: 8px; font-size: 12px; max-height: 240px; overflow: auto; white-space: pre-wrap; word-break: break-all; }
  }
  .job-error {
    background: #fef0f0;
    border: 1px solid #fde2e2;
    border-radius: 4px;
    padding: 8px 10px;
    margin-bottom: 8px;
    strong { color: #f56c6c; }
    p { margin: 4px 0 0; color: #f56c6c; font-size: 13px; }
  }
  .danger { color: #f56c6c; }
  .job-event-list {
    max-height: 280px;
    overflow: auto;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    .event-row {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 6px 10px;
      border-bottom: 1px solid #f0f2f5;
      font-size: 13px;
      strong { min-width: 110px; color: #19bd92; }
      span { flex: 1; color: #606266; }
      small { color: #909399; }
    }
  }
</style>
<style>
  .page_batchJobManage .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }
  .page_batchJobManage .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }
  .page_batchJobManage .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
  .page_batchJobManage .el-collapse-item__header { line-height: 28px; height: auto; padding: 6px 0; }
  .page_batchJobManage .el-collapse-item__content { padding-bottom: 10px; }
</style>
